"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6499,4436],{

/***/ 66499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CARD": function() { return /* binding */ CARD; },
/* harmony export */   "CARD_SHAPE_DROPDOW": function() { return /* binding */ CARD_SHAPE_DROPDOW; },
/* harmony export */   "PRODUCT_CONTENT_CONFIG_FOR_L1_L2": function() { return /* binding */ PRODUCT_CONTENT_CONFIG_FOR_L1_L2; },
/* harmony export */   "PRODUCT_CONTENT_CONFIG_FOR_L3": function() { return /* binding */ PRODUCT_CONTENT_CONFIG_FOR_L3; },
/* harmony export */   "PRODUCT_TESTIMONIALS_CARD_CONFIG": function() { return /* binding */ PRODUCT_TESTIMONIALS_CARD_CONFIG; },
/* harmony export */   "PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS": function() { return /* binding */ PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS; },
/* harmony export */   "PRODUCT_TESTIMONIALS_LAYOUT": function() { return /* binding */ PRODUCT_TESTIMONIALS_LAYOUT; },
/* harmony export */   "PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG": function() { return /* binding */ PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG; },
/* harmony export */   "PRODUCT_TESTIMONIAL_BUILDER_CONFIG": function() { return /* binding */ PRODUCT_TESTIMONIAL_BUILDER_CONFIG; },
/* harmony export */   "PRODUCT_TESTIMONIAL_GAP": function() { return /* binding */ PRODUCT_TESTIMONIAL_GAP; },
/* harmony export */   "SPEED_OPTION": function() { return /* binding */ SPEED_OPTION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42381);
/* harmony import */ var _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89489);
/* harmony import */ var src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37179);
/* harmony import */ var src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79834);
/* harmony import */ var _components_RowItemImageText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94436);
/* harmony import */ var _MultiColumn_MultiColumnStaticValues__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8340);
/* harmony import */ var _ListPresentation_ListPresentationConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99719);
/* harmony import */ var src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16902);
/* harmony import */ var _GlobalStyle_globalSettingConstant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88403);










var PRODUCT_TESTIMONIALS_LAYOUT = [
    {
        name: "layout1",
        heading: "Layout 1",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/dzJxwHTf.webp",
        // These are the base configs meapped with each layout
        list: {
            layoutName: "layout1",
            appearance: "standard",
            layoutType: "carousel",
            numColumnsDesktop: 3,
            textAlign: "left"
        },
        card: {
            productPosition: "top"
        }
    },
    {
        name: "layout2",
        heading: "Layout 2",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/yD9huIdb.webp",
        // These are the base configs mapped with each layout
        list: {
            layoutName: "layout2",
            appearance: "standard",
            layoutType: "carousel",
            numColumnsDesktop: 1
        },
        card: {
            productPosition: "left"
        }
    },
    {
        name: "layout3",
        heading: "Layout 3",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/MVBkJJx1.webp",
        // These are the base configs mapped with each layout
        list: {
            layoutName: "layout3",
            appearance: "standard",
            layoutType: "carousel",
            numColumnsDesktop: 3
        },
        card: {
            productPosition: "top"
        }
    },
    {
        name: "layout4",
        heading: "Layout 4",
        cdn: "https://cdn.dotpe.in/longtail/themes/8073865/C9ZDbE3v.webp",
        // These are the base configs mapped with each layout
        list: {
            layoutName: "layout4",
            appearance: "standard",
            layoutType: "carousel",
            numColumnsDesktop: 1,
            numColumnsMobile: 1,
            textAlign: "center",
            autoPlayConfig: {
                type: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE,
                autoplayTimer: 22.5,
                autoRotateTimer: 4
            }
        },
        card: {
            textAlign: "center"
        }
    }, 
];
var PRODUCT_TESTIMONIAL_GAP = {
    layout1: {
        row: {
            mobile: 44,
            desktop: 60
        },
        carousel: {
            mobile: 16,
            desktop: 44
        },
        grid: {
            mobile: 16,
            desktop: 44
        },
        card: {
            desktop: 20,
            mobile: 12
        }
    },
    layout2: {
        row: {
            mobile: 44,
            desktop: 60
        },
        grid: {
            mobile: 16,
            desktop: 44
        },
        carousel: {
            mobile: 16,
            desktop: 44
        },
        card: {
            desktop: 20,
            mobile: 12
        }
    },
    layout3: {
        row: {
            mobile: 36,
            desktop: 60
        },
        grid: {
            mobile: 16,
            desktop: 44
        },
        carousel: {
            mobile: 16,
            desktop: 44
        },
        card: {
            desktop: 20,
            mobile: 12
        }
    },
    layout4: {
        row: {
            mobile: 12,
            desktop: 20
        },
        grid: {
            mobile: 12,
            desktop: 20
        },
        carousel: {
            mobile: 12,
            desktop: 20
        }
    }
};
var PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS = {
    layout1: {
        cardWrapperConfig: {
            showBorder: false,
            padding: "35px 28px"
        },
        productImageConfig: {
            maxHeight: 350
        },
        productImageMobileConfig: {
            maxHeight: 350
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: true,
            imageType: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_TYPES.CIRCLE */ .v5.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 24
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout2: {
        cardWrapperConfig: {
            showBorder: false,
            padding: "35px 28px"
        },
        productImageConfig: {
            maxHeight: 300,
            minWidth: 120,
            maxWidth: 450
        },
        productImageMobileConfig: {
            maxHeight: 300,
            minWidth: 120,
            maxWidth: 450
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: true,
            imageType: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_TYPES.CIRCLE */ .v5.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 24
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout3: {
        cardWrapperConfig: {
            showBorder: false,
            flexDirection: "column",
            gap: 18
        },
        productImageConfig: {
            height: 80,
            width: 80
        },
        productImageMobileConfig: {
            height: 56,
            width: 56
        },
        imageConfig: {
            showImage: true,
            showImageWithAuthorInfo: false,
            imageType: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_TYPES.CIRCLE */ .v5.CIRCLE,
            width: 76,
            height: 76
        },
        infoWrapperConfig: {
            gap: 10.5
        },
        reviewConfig: {},
        authorInfoConfig: {
            gap: 0,
            alignItems: "center",
            authornameConfig: {
                fontSize: 14,
                lineHeight: "20px",
                fontWeight: 600
            },
            authorProfileConfig: {
                fontWeight: 400
            }
        }
    },
    layout4: {
        showAuthorImageList: true,
        cardWrapperConfig: {
            showBorder: false,
            paddingBottom: 100
        },
        imageConfig: {
            showImage: false,
            showImageWithAuthorInfo: false,
            imageType: src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .IMAGE_TYPES.CIRCLE */ .v5.CIRCLE,
            width: 40,
            height: 40
        },
        infoWrapperConfig: {
            gap: 16
        },
        reviewConfig: {
            marginTop: 8,
            gap: 16
        },
        authorInfoConfig: {}
    }
};
var SPEED_OPTION = [
    {
        text: "Slowest",
        value: 45
    },
    {
        text: "Slow",
        value: 30
    },
    {
        text: "Normal",
        value: 22.5
    }, 
];
var PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG = {
    layoutName: "layout1",
    viewLabel: "Product testimonials",
    widgetName: src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__/* .ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */ .Pe.PRODUCT_TESTIMONIALS.type,
    layoutType: "carousel",
    heading: "<h1>Customers love our products</h1>",
    descriptionPosition: "below",
    textAlign: "left",
    headingCharCount: 0,
    instagramAccount: "",
    description: "",
    descriptionCharCount: 0,
    type: src_constants_widgets__WEBPACK_IMPORTED_MODULE_0__/* .ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */ .Pe.PRODUCT_TESTIMONIALS.type,
    colors: {
        selectedColorSchemeIndex: 0,
        colorSchemes: [
            {
                background: "#ffffff",
                text: "#000000",
                isDefault: true
            },
            {
                background: "#000000",
                text: "#ffffff",
                isDefault: false
            }, 
        ]
    },
    contentItems: {
        isAllSelected: false,
        type: "testimonials",
        listItem: []
    },
    appearance: "standard",
    imageWidth: "fullWidth",
    backgroundColor: "#FFFFFF",
    borderColor: "#E2E4E7",
    numColumnsDesktop: 3,
    numColumnsMobile: 1,
    mobilePaddingY: 40,
    paddingY: 70,
    marginTop: 0,
    marginBottom: 0,
    autoPlayConfig: {
        type: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.MANUAL */ .ej.MANUAL,
        autoplayTimer: 22.5,
        autoRotateTimer: 4
    },
    viewAllItemsButtonConfig: [
        (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultConfig */ ._K)("bannerButton", "#111C36", "#FFFFFF", "View all"), 
    ]
};
var PRODUCT_TESTIMONIALS_CARD_CONFIG = {
    cardShape: "portraitTall",
    aspectRatio: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .ASPECT_RATIO_MAP.portraitTall */ .Jg.portraitTall,
    productAspectRatio: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .ASPECT_RATIO_MAP.square */ .Jg.square,
    productPosition: "top",
    hoverEffect: "zoomIn",
    textAlign: "left",
    textSizeDesktop: "medium",
    textSizeMobile: "medium",
    headlineSizeDesktop: "medium",
    headlineSizeMobile: "small",
    headlineColor: "#111C36",
    reviewColor: "#111C36E6",
    authorNameColor: "#111C36",
    designationColor: "#111C36B3",
    ratingColor: "#F9CC43",
    textThickness: "regular",
    headlineThickness: "semiBold",
    textCase: "none",
    headlineCase: "none",
    hoverType: "zoomIn",
    showRatings: true,
    showImage: true,
    imageSizeDesktop: 40,
    imageSizeMobile: 40,
    authorImagePosition: "withAuthorInfo",
    imageShape: "circle",
    productImageShape: "square",
    testimonialsList: [],
    selectedReviewsId: [],
    childElementOrder: [
        {
            name: "Rating",
            id: "rating",
            isSortable: true
        },
        {
            name: "Review",
            id: "review",
            isSortable: true
        },
        {
            name: "Author info",
            id: "authorInfo",
            isSortable: true
        }, 
    ],
    buttonConfig: [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,src_components_WidgetMaker_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultConfig */ ._K)("bannerButton", "#111C36", "#FFFFFF", "Shop now")), 
    ]
};
var CARD_SHAPE_DROPDOW = [
    {
        value: "square",
        renderData: function() {
            return (0,_components_RowItemImageText__WEBPACK_IMPORTED_MODULE_4__/* .getCardShare */ .e)("Square");
        }
    },
    {
        value: "circle",
        renderData: function() {
            return (0,_components_RowItemImageText__WEBPACK_IMPORTED_MODULE_4__/* .getCardShare */ .e)("Circle");
        }
    },
    {
        value: "smart",
        renderData: function() {
            return (0,_components_RowItemImageText__WEBPACK_IMPORTED_MODULE_4__/* .getCardShare */ .e)("Logo friendly (Smart fit in Rectangle or square)");
        }
    }, 
];
var PRODUCT_CONTENT_CONFIG_FOR_L1_L2 = [
    {
        text: "Top",
        value: "top"
    },
    {
        text: "Bottom",
        value: "bottom"
    }
];
var PRODUCT_CONTENT_CONFIG_FOR_L3 = [
    {
        text: "Left",
        value: "left"
    },
    {
        text: "Right",
        value: "right"
    }
];
var PRODUCT_TESTIMONIAL_BUILDER_CONFIG = {
    sectionContent: {
        sectionHeading: "Section content",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "layout",
                componentLabel: "Heading",
                element: "inputEditor",
                accessKey: [
                    "heading"
                ],
                charCountKey: "headingCharCount",
                placeholder: "Enter title",
                maxLength: 100
            },
            {
                forType: "layout",
                componentLabel: "Description",
                element: "inputEditor",
                placeholder: "Enter description",
                charCountKey: "descriptionCharCount",
                accessKey: [
                    "description"
                ],
                textColor: "#808080",
                maxLength: 100
            },
            {
                forType: "layout",
                componentLabel: "Description position",
                element: "multiselect",
                accessKey: [
                    "descriptionPosition"
                ],
                componentData: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .DESCRIPTION_POSITION */ .gg
            },
            {
                forType: "layout",
                componentLabel: "Heading alignment",
                element: "multiselect",
                accessKey: [
                    "textAlign"
                ],
                componentData: _MultiColumn_MultiColumnStaticValues__WEBPACK_IMPORTED_MODULE_5__/* .HEADING_ALIGNMENT */ .Rt
            },
            {
                forType: "layout",
                componentLabel: "Section colour",
                editLabel: "Edit colour",
                uniqueKey: "selectionColors",
                element: "colorsCombination",
                accessKey: [
                    "colors"
                ]
            }, 
        ]
    },
    imageAndRatings: {
        sectionHeading: "Image and ratings",
        description: "",
        tooltipContent: "",
        builder: [
            {
                element: "renderWithHeading",
                heading: "",
                child: [
                    {
                        forType: "card",
                        element: "checkbox",
                        componentLabel: "Show ratings",
                        accessKey: [
                            "showRatings"
                        ]
                    }, 
                ]
            },
            {
                forType: "card",
                element: "dropdown",
                componentLabel: "Product image shape",
                accessKey: [
                    "productImageShape"
                ],
                componentData: _ListPresentation_ListPresentationConfig__WEBPACK_IMPORTED_MODULE_6__.CARD_SHAPE_DROPDOWN,
                customChildRender: true,
                placeholder: ""
            },
            {
                forType: "layoutItem",
                element: "dropdown",
                componentLabel: "hover effect",
                accessKey: [
                    "hoverEffect"
                ],
                dropdownData: _MultiColumn_MultiColumnStaticValues__WEBPACK_IMPORTED_MODULE_5__/* .HOVER_EFFECT_DROPDOWN */ .JL,
                customChildRender: false,
                placeholder: ""
            }, 
        ]
    },
    layoutAndDesign: {
        sectionHeading: "Layout & design",
        description: "",
        tooltipContent: "",
        builder: [
            {
                componentLabel: "Layout/design",
                element: "testimonialLayout",
                componentData: PRODUCT_TESTIMONIALS_LAYOUT
            },
            {
                forType: "layout",
                element: "multiselect",
                componentLabel: "Layout style",
                accessKey: [
                    "layoutType"
                ],
                dynamicData: false,
                componentData: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .LAYOUT_STYLE */ .R_,
                renderConditional: true,
                isVisible: function(activeWidgetProps) {
                    var ref;
                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) !== "layout4";
                }
            },
            {
                forType: "layout",
                componentLabel: "Number of columns - Desktop",
                element: "slider",
                accessKey: [
                    "numColumnsDesktop"
                ],
                min: 1,
                max: 2,
                dynamicData: true,
                getDynamicData: function(activeWidgetProps) {
                    var layoutPresentation = activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.listPresentation;
                    switch(layoutPresentation.layoutName){
                        case src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.FOUR */ .o_.FOUR:
                            return {
                                min: 1,
                                max: 1
                            };
                        case src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.TWO */ .o_.TWO:
                            return {
                                min: 1,
                                max: 2
                            };
                        default:
                            return {
                                min: 1,
                                max: 4
                            };
                    }
                },
                suffix: "",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Number of columns - Mobile",
                element: "slider",
                accessKey: [
                    "numColumnsMobile"
                ],
                min: 1,
                max: 2,
                dynamicData: true,
                getDynamicData: function getDynamicData(activeWidgetProps) {
                    var layoutPresentation = activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.listPresentation;
                    if (layoutPresentation.layoutName === "layout4") {
                        return {
                            min: 1,
                            max: 1
                        };
                    }
                    return {
                        min: 1,
                        max: 2
                    };
                },
                suffix: "",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Review appearance",
                element: "multiselect",
                accessKey: [
                    "appearance"
                ],
                componentData: _GlobalStyle_globalSettingConstant__WEBPACK_IMPORTED_MODULE_8__/* .PRODUCT_APPEARANCE_DATA */ .aY,
                renderConditional: true,
                isVisible: function(activeWidgetProps) {
                    var ref;
                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.layoutName) !== "layout4";
                }
            },
            {
                element: "colorDetails",
                componentLabel: "Colour",
                isVisible: function(activeWidgetProps) {
                    var ref;
                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.appearance) === "card";
                },
                conditionalRender: true,
                forType: "layout",
                colorsData: [
                    {
                        forType: "layout",
                        text: "backgroundColor",
                        isVisible: function(activeWidgetProps) {
                            var ref;
                            return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.appearance) === "card";
                        },
                        renderConditional: true,
                        displayVal: "Background colour",
                        accessKey: [
                            "backgroundColor"
                        ],
                        shouldUpdateData: false,
                        data: []
                    },
                    {
                        forType: "layout",
                        text: "borderColor",
                        isVisible: function(activeWidgetProps) {
                            var ref;
                            return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : ref.appearance) === "card";
                        },
                        renderConditional: true,
                        displayVal: "Border colour",
                        accessKey: [
                            "borderColor"
                        ],
                        shouldUpdateData: false,
                        data: []
                    }, 
                ]
            }, 
        ]
    },
    testimonialsContent: {
        sectionHeading: "Testimonials content",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "card",
                componentLabel: "Content alignment",
                element: "multiselect",
                accessKey: [
                    "textAlign"
                ],
                componentData: _MultiColumn_MultiColumnStaticValues__WEBPACK_IMPORTED_MODULE_5__/* .HEADING_ALIGNMENT */ .Rt
            },
            {
                forType: "card",
                element: "dropdown",
                componentLabel: "Product testimonial text size - Desktop",
                accessKey: [
                    "textSizeDesktop"
                ],
                dropdownData: _ListPresentation_ListPresentationConfig__WEBPACK_IMPORTED_MODULE_6__.TEXT_SIZE_DROPDOWN,
                customChildRender: false,
                placeholder: ""
            },
            {
                forType: "card",
                element: "dropdown",
                componentLabel: "Product testimonial text size - Mobile",
                accessKey: [
                    "textSizeMobile"
                ],
                dropdownData: _ListPresentation_ListPresentationConfig__WEBPACK_IMPORTED_MODULE_6__.TEXT_SIZE_DROPDOWN,
                customChildRender: false,
                placeholder: ""
            },
            // {
            //   forType: 'card',
            //   element: 'dropdown',
            //   componentLabel: 'Headline size - Desktop',
            //   accessKey: ['headlineSizeDesktop'],
            //   dropdownData: TEXT_SIZE_DROPDOWN,
            //   customChildRender: false,
            //   placeholder: '',
            // },
            // {
            //   forType: 'card',
            //   element: 'dropdown',
            //   componentLabel: 'Headline size - Mobile',
            //   accessKey: ['headlineSizeMobile'],
            //   dropdownData: TEXT_SIZE_DROPDOWN,
            //   customChildRender: false,
            //   placeholder: '',
            // },
            {
                componentLabel: "Advanced settings",
                componentSubLabel: "Customise Text casing, content thickness, colour.",
                element: "customModal",
                modalHeading: "Advance settings",
                componentData: [
                    {
                        element: "colorDetails",
                        componentLabel: "Colours",
                        forType: "card",
                        colorsData: [
                            {
                                forType: "card",
                                text: "reviewColor",
                                displayVal: "Review color",
                                accessKey: [
                                    "reviewColor"
                                ],
                                shouldUpdateData: false,
                                data: []
                            },
                            {
                                forType: "card",
                                text: "authorNameColor",
                                displayVal: "Author name color",
                                accessKey: [
                                    "authorNameColor"
                                ],
                                shouldUpdateData: false,
                                data: []
                            },
                            {
                                forType: "card",
                                text: "ratingColor",
                                displayVal: "Rating color",
                                accessKey: [
                                    "ratingColor"
                                ],
                                shouldUpdateData: false,
                                data: []
                            }, 
                        ]
                    },
                    {
                        forType: "card",
                        componentLabel: "Review text case",
                        element: "multiselect",
                        accessKey: [
                            "textCase"
                        ],
                        componentData: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .TEXT_CASE */ .PA
                    },
                    {
                        forType: "card",
                        element: "dropdown",
                        componentLabel: "Review thickness",
                        accessKey: [
                            "textThickness"
                        ],
                        dropdownData: src_constants_builderConstants__WEBPACK_IMPORTED_MODULE_3__/* .TEXT_THICKNESS */ .MX,
                        customChildRender: false,
                        placeholder: ""
                    }, 
                ]
            }, 
        ]
    },
    carouselBehaviour: {
        sectionHeading: "Carousel behaviour",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "layout",
                componentLabel: "",
                element: "radioButton",
                accessKey: [
                    "autoPlayConfig",
                    "type"
                ],
                conditionalStyle: false,
                componentData: [
                    {
                        label: "Manual scroll (default)",
                        id: "autoOff",
                        value: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.MANUAL */ .ej.MANUAL
                    },
                    {
                        label: "Auto-scroll",
                        id: "autoOn",
                        value: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL,
                        child: [
                            {
                                forType: "layout",
                                element: "multiselect",
                                componentData: SPEED_OPTION,
                                renderConditional: true,
                                accessKey: [
                                    "autoPlayConfig",
                                    "autoplayTimer"
                                ],
                                isVisible: function(activeWidgetProps) {
                                    var ref, ref1;
                                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : (ref1 = ref.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.type) === _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL;
                                },
                                placeholder: ""
                            }, 
                        ]
                    },
                    {
                        label: "Auto-rotate testimonials",
                        id: "autoOn",
                        value: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE,
                        child: [
                            {
                                forType: "layout",
                                element: "autoSlide",
                                componentLabel: "Change testimonial every:",
                                accessKey: [
                                    "autoPlayConfig",
                                    "autoRotateTimer"
                                ],
                                min: 4,
                                max: 6,
                                renderConditional: true,
                                isVisible: function(activeWidgetProps) {
                                    var ref, ref1;
                                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : (ref1 = ref.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.type) === _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE;
                                },
                                placeholder: ""
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    },
    reelBehaviour: {
        sectionHeading: "Autoplay",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "layout",
                componentLabel: "",
                element: "radioButton",
                accessKey: [
                    "autoPlayConfig",
                    "type"
                ],
                conditionalStyle: false,
                componentData: [
                    {
                        label: "On",
                        id: "autoOn",
                        value: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE,
                        child: [
                            {
                                forType: "layout",
                                element: "autoSlide",
                                componentLabel: "Change testimonial every:",
                                accessKey: [
                                    "autoPlayConfig",
                                    "autoRotateTimer"
                                ],
                                min: 4,
                                max: 6,
                                renderConditional: true,
                                isVisible: function(activeWidgetProps) {
                                    var ref, ref1;
                                    return (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : (ref = activeWidgetProps.listPresentation) === null || ref === void 0 ? void 0 : (ref1 = ref.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.type) === _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE;
                                },
                                placeholder: ""
                            }, 
                        ]
                    },
                    {
                        label: "Off",
                        id: "autoOff",
                        value: _NewAnnouncementBar_Constants__WEBPACK_IMPORTED_MODULE_1__/* .SCROLL_TYPE.MANUAL */ .ej.MANUAL
                    }, 
                ]
            }, 
        ]
    },
    contentOrderSection: {
        sectionHeading: "Content order",
        description: "",
        tooltipContent: "",
        builder: [
            {
                forType: "card",
                componentLabel: "Product position",
                element: "multiselect",
                accessKey: [
                    "productPosition"
                ],
                dynamicData: true,
                getDynamicData: function(param) {
                    var listPresentation = param.listPresentation;
                    if ((listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) === src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.ONE */ .o_.ONE || (listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) === src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.THREE */ .o_.THREE) {
                        return PRODUCT_CONTENT_CONFIG_FOR_L1_L2;
                    }
                    return PRODUCT_CONTENT_CONFIG_FOR_L3;
                },
                renderConditional: true,
                dynamicSubText: function(param) {
                    var listPresentation = param.listPresentation;
                    if ((listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) === src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.TWO */ .o_.TWO) {
                        return "Image Positioned at the Top in Mobile for optimal viewing experience.";
                    }
                },
                isVisible: function(param) {
                    var listPresentation = param.listPresentation;
                    return (listPresentation === null || listPresentation === void 0 ? void 0 : listPresentation.layoutName) !== src_components_DesignSystem_Widgets2_0_ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_7__/* .COMMON_LAYOUT_TYPE.FOUR */ .o_.FOUR;
                }
            }, 
        ]
    },
    viewAllButton: {
        builder: [
            {
                forType: "layout",
                element: "button",
                buttonHeading: "View all",
                subHeading: "This button will be visible when all testimonials are not in display at front.",
                showColorCombination: true,
                showDeleteIcon: false,
                showRedirectionField: false,
                accessKey: [
                    "viewAllItemsButtonConfig"
                ]
            }, 
        ]
    },
    sectionSetting: {
        sectionHeading: "Section settings",
        builder: [
            {
                forType: "layout",
                componentLabel: "Desktop padding top and bottom",
                element: "slider",
                accessKey: [
                    "paddingY"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Mobile padding top and bottom",
                element: "slider",
                accessKey: [
                    "mobilePaddingY"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Margin top",
                element: "slider",
                accessKey: [
                    "marginTop"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            },
            {
                forType: "layout",
                componentLabel: "Margin bottom",
                element: "slider",
                accessKey: [
                    "marginBottom"
                ],
                min: 0,
                max: 100,
                suffix: "px",
                step: 1
            }, 
        ]
    },
    configReset: {
        builder: [
            {
                forType: "layout",
                element: "reset",
                heading: "Reset to defaults",
                subHeading: "All settings of this section - layout, design etc. will be reset to default."
            }, 
        ]
    }
};
var CARD = "card";


/***/ }),

/***/ 94436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getCardShare; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getCardShare = function(text) {
    var spiteDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-flex tw-items-center tw-gap-[10px]",
        children: [
            !!spiteDetails && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "wb-sprite ".concat(spiteDetails)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: text
            })
        ]
    });
};


/***/ })

}]);